<app-notification-sound
  [audio]="{name:'Campainha', file:'campainha'}"
  [audioList]="audioList2"
  notificationType="alert"
  headerTitle="Som de alerta de novo lead"
  tooltip="Defina o som de alerta de novo lead"
></app-notification-sound>

<app-notification-sound
  [audio]="{name: 'Swiftly', file:'swiftly'}"
  [audioList]="audioList"
  notificationType="notification"
  headerTitle="Som de notificações"
  tooltip="Defina o som de todas as outras notificações"
></app-notification-sound>

<div class="container">
  <p class="title">Assinatura</p>
  <textarea id="user-signature" maxlength="1000">{{defaultMessage}}</textarea>
</div>

<div class="bottom-bar">
  <lib-button-tertiary id="cancel-button">Cancelar</lib-button-tertiary>
  <lib-button-primary id="save-button">Salvar</lib-button-primary>
</div>